import { render, staticRenderFns } from "./kpiTaskGanttTabs.vue?vue&type=template&id=6219ea19&"
import script from "./kpiTaskGanttTabs.vue?vue&type=script&lang=js&"
export * from "./kpiTaskGanttTabs.vue?vue&type=script&lang=js&"
import style0 from "./kpiTaskGanttTabs.vue?vue&type=style&index=0&id=6219ea19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports